import { Fragment } from "react";
import { Table } from "reactstrap";
import { format } from "date-fns";
import { ReportDetailsView } from "./reportDetailsView";

export const UnprocessedReports = (props) => {
  const { abuseReports, loading, setCompletingReview, setReview } = props;

  return (
    <Fragment>
      <div className="rounded px-3 px-sm-4 py-3 py-sm-5">
        <h1 className="display-3">Neue Meldungen</h1>
      </div>
      <Table>
        <thead>
          <tr>
            <th>Grund</th>
            <th>Genauerer Grund</th>
            <th>Content Titel</th>
            <th>Contributor</th>
            <th>ContentType</th>
            <th>gemeldet von</th>
            <th>Datum</th>
          </tr>
        </thead>
        {loading && <p>Loading</p>}
        <tbody>
          {abuseReports.map((report) => {
            return (
              <Fragment>
                <tr
                  id={"toggler" + report._id}
                  style={{ marginBottom: "10px" }}
                >
                  <td>{report.reason}</td>
                  <td>{report.subreason}</td>
                  <td>{report.contentTitle}</td>
                  <td>{report.contentContributor}</td>
                  <td>{report.contentType}</td>
                  <td style={{ fontWeight: "bold" }}>
                    {report.contributor.username}
                  </td>
                  <td>
                    {format(
                      new Date(parseInt(report.createdAt)),
                      "dd/MM/yyyy HH:mm",
                    )}
                  </td>
                </tr>
                <tr>
                  <td className={"p-0"} colSpan={7}>
                    <ReportDetailsView
                      report={report}
                      setCompletingReview={setCompletingReview}
                      setReview={setReview}
                    />
                  </td>
                </tr>
              </Fragment>
            );
          })}
        </tbody>
      </Table>
    </Fragment>
  );
};
